export default __webpack_public_path__ + "static/rna-5ce66276b1ae50ed5853a8437349a14c.png";